<template>
  <ion-page>
    <master-layout pageTitle="لیست محصولات انبار">
      <ion-card>
        <ion-card-content>
          <DataTable auto-reload="1" :headers="headers" :route="route" ></DataTable>
          <div v-if="currentUser && !currentUser.just_app" class="d-flex-between">
            <div></div>
            <div>جمع کل :
            <money :number="total"></money>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions, mapGetters} from "vuex";
import Money from "@/components/Money";

export default {
  data()
  {
    return {
      id:null,
      route:null,
      total : 0,
      headers:[
        'نام محصول',
        'ویژگی',
        'تعداد موجودی',
        'قیمت فروش',
        'قیمت خرید',
          'جمع',
        'امکانات'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.warehouseId;
    this.route = 'WarehouseProduct/ListAjax/'+this.id;
    if (this.currentUser && this.currentUser.just_app)
      this.headers = [
        'نام محصول',
        'ویژگی',
        'تعداد موجودی',
        'قیمت فروش',
      ]
  },
  async mounted()
  {
    const check = await this.getWarehouseTotalBuyPrice();
    if (check.ok)
    {
      this.total = check.total;
    }
  },
  methods:{
    ...mapActions("app", {
      getWarehouseTotalBuyPrice: 'getWarehouseTotalBuyPrice',
    }),
  },
  components: {
    Money,
    IonCard, IonCardContent, DataTable, IonPage
  },
  computed: {
    ...mapGetters("auth", {
      currentUser: "getUserInfo",
    }),
  },
  watch: {
    // '$route.path': {
    //   handler(newUrl)
    //   {
    //     console.log(newUrl)
    //     if (newUrl.indexOf('WarehouseProduct/List/') >= 0)
    //     {
    //       this.id = this.$route.params.warehouseId;
    //       this.route = 'WarehouseProduct/ListAjax/'+this.id+'?t=' + (new Date().getTime())
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>
.d-flex-between {
  display: flex;
  justify-content: space-between;
  text-align: left;
}
</style>